import { render, staticRenderFns } from "./DhxGrid.vue?vue&type=template&id=20f11f72&scoped=true"
import script from "./DhxGrid.vue?vue&type=script&lang=js"
export * from "./DhxGrid.vue?vue&type=script&lang=js"
import style0 from "./DhxGrid.vue?vue&type=style&index=0&id=20f11f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f11f72",
  null
  
)

export default component.exports